import { GenericError, IErrorDetails } from '@cian/peperrors/shared';

/** Этот пример взят из доки peperrors */
/* istanbul ignore next */
export class BadRequestError extends GenericError {
  public constructor(configuration: { domain: string; message: string; details?: IErrorDetails }) {
    super({
      ...configuration,
      type: 'BadRequestError',
    });

    // Необходимо из-за особенности реализации наследования в TS. Иначе не будет работать instanceof BadRequestError
    Object.setPrototypeOf(this, BadRequestError.prototype);

    // Данный код не является обязательным, он нужен для того, чтобы не было лишнего слоя в стэктрейсе
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, BadRequestError);
    } else {
      this.stack = new Error().stack;
    }
  }
}
